import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const ImageWrapper = styled.div`
  left: 0;
  top: 0;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 654px;

  ${breakpoints.lg} {
    justify-content: center;
  }

  img {
    height: 100%;
    flex-shrink: 0;
    object-fit: cover;
    width: 100%;
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    height: 100%;
    z-index: 1;
    width: 100%;
    display: block;
    background: linear-gradient(0deg, rgba(16, 16, 16, 0.70) 0%, rgba(16, 16, 16, 0.00) 76.10%, rgba(16, 16, 16, 0.00) 100%);
  }

    ${breakpoints.md} {
      top: 0;
    }
  }
`;
